<template>
  <b-card class="shadow" style="min-height: 700px" id="printme">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Todas as situações de Violação de Direitos") }}
          </h5>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div class="col-12" v-if="viewFilterReport">
        <!-- Filtros -->
        <form @submit.prevent="getAnalytics" ref="addItem">
          <div class="row">
            <form-calendar
              v-model="data_inicio"
              grid="3"
              label="Data inicial"
            />

            <form-calendar
              v-model="data_fim"
              grid="3"
              label="Data final"
              :required="verificaDataInicial"
              :min-date="data_inicio"
            />

            <form-select
              v-model="filtroTipos"
              grid="6"
              label="Por tipo(s)"
              :itens="tipos"
              :loading="loadingTipos"
              :disabled="loadingTipos"
              multiple
            />

            <div class="col-md-8">
              <label><b>Pesquisar</b></label>
              <div class="input-group">
                <b-input
                  placeholder="Protocolo ou usuário"
                  class="form-control search-input"
                  type="text"
                  v-model="search"
                  aria-describedby="input-search"
                />
              </div>
              <p class="small text-muted">
                No campo acima você pode pesquisar por: Protocolo ou usuário.
              </p>
            </div>

            <form-select
              v-model="filtroStatus"
              grid="4"
              label="Status"
              :itens="status"
              :loading="loadingStatus"
              :disabled="loadingStatus"
              multiple
            />

            <form-select
              v-model="filtroUnidades"
              label="Unidade(s)"
              grid="6"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              multiple
              @input="getTecnicos()"
            />

            <form-select
              v-model="filtroTecnicos"
              label="Técnico responsável"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnico"
              :grid="6"
              placeholder="Selecione uma unidade antes"
              multiple
            />

            <form-select
              v-model="filtroTecnicosAutor"
              label="Técnico Autor"
              :itens="listtecnicos"
              :disabled="loadingSearchTecnico"
              :grid="6"
              placeholder="Selecione uma unidade antes"
              multiple
            />

            <form-toggle
              class="d-flex justify-content-start"
              mt="0"
              v-model="filtroAcomp"
              label="Situações acompanhadas?"
            />

            <form-select
              v-model="filtroUnidadesAcomp"
              label="Unidade acompanhamento"
              grid="12"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              multiple
              @input="getTecnicosAcomp()"
              v-if="filtroAcomp"
            />

            <!-- <form-select
              v-model="filtroTecnicosAcomp"
              label="Orientador social"
              :itens="listtecnicosacomp"
              :disabled="loadingSearchTecnicoAcomp"
              :grid="6"
              placeholder="Selecione uma unidade antes"
              multiple
              v-if="filtroAcomp"
            /> -->

            <!-- <form-toggle
              v-model="showfiltroIdade"
              grid="12"
              label="Filtrar por intervalo de idade?"
            /> -->

            <div class="col-md-12 mt-3 mb-5" v-if="showfiltroIdade">
              <label><b>Idade</b></label>
              <vue-slider
                v-model="filtroIdade"
                :min="min"
                :max="max"
                :tooltip="'always'"
                :tooltip-placement="'bottom'"
              ></vue-slider>
            </div>
          </div>
          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                class="btn btn-default"
                @click.prevent="limparFiltros(), (viewFilterReport = false)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros()"
              >
                {{ $t("Limpar Filtros") }}
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      ></loading-report>

      <div class="col-md-12">
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />

        <print-content>
          <template v-slot:datas>
            <p class="d-flex align-items-center justify-content-between mb-4">
              <span
                >Período selecionado:
                <b>{{ datas.start }} - {{ datas.end }}</b>
                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i> </b-link
              ></span>

              <span v-if="pagination.total"
                >Total de Registros <b>{{ pagination.total }}</b
                >, total por página
                <b>{{ pagination.perPage }}</b>
              </span>

              <span>
                <a v-if="!showName" @click.prevent="mostrarNome" href="#"
                  ><i class="fas fa-eye"></i> Mostrar Nome de Registro</a
                >
                <a v-else @click.prevent="ocultarNome" href="#"
                  ><i class="fas fa-eye-slash"></i> Ocultar Nome de Registro</a
                >
              </span>
            </p>
          </template>

          <b-table
            :fields="[
              {
                key: 'protocolo',
                label: $t('Detalhes'),
              },
              {
                key: 'violacoes_nomes',
                label: $t('Violações'),
              },
              {
                key: 'cadastrado',
                label: $t('Data'),
              },
              {
                key: 'status_nome',
                label: $t('Status'),
              },
              {
                key: 'actions',
                label: '',
                class: 'text-right no-print',
                thStyle: {
                  width: '95px',
                  minWidth: '95px',
                },
              },
            ]"
            :items="itensList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Usuário(s):<br />
              <ul>
                <li
                  v-for="pessoa in data.item.pessoas_objetos"
                  :key="pessoa.id"
                >
                  <b v-if="pessoa.nome_social">
                    {{ pessoa.nome_social }} ( N.R.: )
                    <span v-if="showName">{{ pessoa.nome_completo }}</span>
                  </b>
                  <b v-else>{{ pessoa.nome_completo }}</b>
                  <small class="d-block">{{ pessoa.idade_extenso }}</small>
                </li>
              </ul>
              <small>
                Protocolo:
                <b>{{ data.item.protocolo }}</b>
                <span class="small d-block">
                  Acompanhamento:
                  <span v-if="data.item.acompanhamento_creas == 1"
                    ><b
                      >SIM - {{ data.item.acomp_data_inicial | formatDate }} -
                      {{ data.item.acomp_data_final | formatDate }}</b
                    ><br />
                    <span v-if="data.item.creas != ''">
                      Unidade acompanhamento:
                      <b>{{ data.item.creas.nome }} </b><br />
                    </span>
                  </span>
                  <b v-else>NÃO</b>
                </span>
                Unidade:
                <b>{{ data.item.unidade ? data.item.unidade.nome : "" }}</b>
                <br />
                Técnico:
                <b>{{
                  data.item.responsavel ? data.item.responsavel.nome : ""
                }}</b>
                <span
                  v-if="
                    data.item.outros_tecnicos &&
                    data.item.outros_tecnicos.length > 0
                  "
                >
                  <span class="d-block">Técnicos Participantes</span>
                  <ol>
                    <li
                      v-for="tecnico in data.item.outros_tecnicos"
                      :key="tecnico"
                    >
                      <small>{{ tecnico["nome"] }}</small>
                    </li>
                  </ol>
                </span>
              </small>
            </template>
            <template v-slot:cell(violacoes_nomes)="data">
              <ol>
                <li v-for="violacoes in data.value" :key="violacoes.id">
                  <small>{{ violacoes.descricao }}</small>
                </li>
              </ol>
            </template>
            <template v-slot:cell(cadastrado)="data">
              {{ data.item.cadastrado }}
            </template>
            <template v-slot:cell(status_nome)="data">
              <span class="small" v-html="data.item.status_nome"></span>
            </template>
            <template v-slot:cell()="data">
              <b-button
                v-if="
                  (user_id !== data.item.user_id &&
                    data.item.tecnicos.indexOf(tecnico_id) != -1) ||
                  data.item.unidade_id == unidade_id
                "
                :title="$t('Visualizar e Imprimir')"
                :to="'/dashboard/violacaodedireitos/show/' + data.item.id"
                target="_blank"
                class="px-2 mb-0"
                size="xs"
                type="button"
                v-b-tooltip.hover
                variant="primary"
              >
                <i class="mdi mdi-eye" />
              </b-button>
              <button
                v-if="user_id == data.item.user_id"
                @click="
                  redirectViolacaodedireitos(
                    data.item.id,
                    data.item.familia_id.id
                  )
                "
                class="px-2 mb-0 btn btn-xs btn-success"
              >
                <i class="mdi mdi-square-edit-outline" />
              </button>
            </template>
            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </print-content>

        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="perPage"
                v-on:change="getAnalytics"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }} {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
        <div class="row no-print mt-4">
          <div class="col-lg-12 col-md-12 text-center align-items-center">
            <b-button
              :title="$t('Visualizar e Imprimir')"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "HomeReportMSE",
  data() {
    return {
      showName: false,
      loading: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnico: true,
      loadingSearchTecnicoAcomp: true,
      range: null,
      itensList: [],
      unidades: [],
      tecnicos: [],
      tecnicosAcomp: [],
      page: 1,
      search: "",
      perPage: 10,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      filtros: {
        unidade: null,
      },
      isLoadingMsg: false,
      filter: false,
      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      role: null,
      loadingStatus: false,
      loadingTipos: false,
      tipos: [],
      status: [],
      datas: [],
      filtroUnidades: [],
      filtroUnidadesAcomp: [],
      filtroTecnicos: [],
      filtroTecnicosAutor: [],
      filtroTecnicosAcomp: [],
      filtroDatas: [],
      filtroStatus: [],
      filtroTipos: [],
      dataNow: moment().format("YYYY/MM/DD"),
      filtroAcomp: false,
      filtroIdade: [],
      showfiltroIdade: false,
      idades: null,
    };
  },
  created() {
    this.min = 0;
    this.max = 120;
    this.enableCross = false;
  },
  mounted() {
    this.getStatus();
    this.getTipos();
    this.getUnidades();
    this.getAnalytics();
  },
  watch: {
    showfiltroIdade(val) {
      this.filtroIdade = val ? [0, 120] : [];
    },
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
    listtecnicosacomp() {
      const pessoas = this.tecnicosAcomp;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      if (this.filtroIdade && this.filtroIdade.length > 0) {
        this.idades =
          "Usuários com Idade entre: " +
          this.filtroIdade[0] +
          " ano(s) e " +
          this.filtroIdade[1] +
          " ano(s)";
      }

      axios
        .get("api/dashboard/report/violacaodedireitos/home", {
          params: {
            page: this.page,
            filtroSearch: this.search,
            perPage: this.perPage,
            range: this.range,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroTecnicosAutor: this.filtroTecnicosAutor,
            filtroUnidadesAcomp: this.filtroUnidadesAcomp,
            filtroTecnicosAcomp: this.filtroTecnicosAcomp,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroTipos: this.filtroTipos,
            filtroAcomp: this.filtroAcomp,
            filtroIdade: this.filtroIdade,
          },
        })
        .then((response) => {
          this.loading = false;

          this.user_id = this.$store.state.user.id;
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.unidade_id = this.$store.state.unidade;
          this.role = this.$store.state.user.role;

          this.datas = response.data.datas;
          this.itensList = response.data.dados.original.data;
          this.pagination = response.data.dados.original.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getAnalytics();
          } else {
            this.isLoadingMsg = false;
            this.loading = false;
          }
        })
        .catch(() => {
          this.isLoadingMsg = false;
          this.loading = false;
        });
      this.isLoadingMsg = false;
    },
    exportar() {
      this.isLoadingMsg = true;

      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/violacaodedireitos/home", {
          params: {
            export: "ok",
            page: this.page,
            filtroSearch: this.search,
            perPage: this.perPage,
            range: this.range,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            filtroTecnicosAutor: this.filtroTecnicosAutor,
            filtroUnidadesAcomp: this.filtroUnidadesAcomp,
            filtroTecnicosAcomp: this.filtroTecnicosAcomp,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            filtroTipos: this.filtroTipos,
            filtroAcomp: this.filtroAcomp,
            filtroIdade: this.filtroIdade,
          },
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.isLoadingMsg = false));
    },
    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/status/violacaodedireitos`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    getTipos() {
      this.loadingTipos = true;
      axios.get(`api/dashboard/violacaodedireitos/tipos`).then((response) => {
        this.tipos = response.data;
        this.loadingTipos = false;
      });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnico = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => (this.loadingSearchTecnico = false));
    },
    getTecnicosAcomp() {
      this.tecnicosAcomp = [];
      this.loadingSearchTecnicoAcomp = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidadesAcomp,
          },
        })
        .then((response) => {
          this.tecnicosAcomp = response.data;
        })
        .finally(() => (this.loadingSearchTecnicoAcomp = false));
    },
    limparFiltros() {
      //   this.filtros = {};
      this.search = "";
      this.data_inicio = null;
      this.data_fim = null;
      this.filtros.data_inicial = null;
      this.filtros.data_final = null;

      this.filtroUnidades = [];
      this.filtroTecnicos = [];
      this.filtroTecnicosAutor = [];
      this.filtroDatas = [];
      this.filtroStatus = [];
      this.filtroTipos = [];

      this.filtroUnidadesAcomp = [];
      this.filtroTecnicosAcomp = [];
      this.filtroAcomp = false;
      this.filtroIdade = [];
      this.showfiltroIdade = false;
      this.idades = null;

      this.range = null;

      this.getAnalytics();
    },
    getViolacoes(value, vddSelecionada) {
      this.violacoes = value;
      this.vddSelecionada = vddSelecionada;
      this.$bvModal.show("modalVerViolacoes");
    },
    redirectViolacaodedireitos(id, familia_id) {
      const url = this.$router.resolve({
        path: `/dashboard/violacaodedireitos/edit/${id}`,
        query: { familia_id: familia_id },
      }).href;

      window.open(url, '_blank');
    },
  },
};
</script>
